import React, {useEffect, useState} from 'react';
import {StyleSheet, FlatList, Dimensions, View} from 'react-native';
import AppText from '../components/AppText';
import Screen from '../components/Screen';
import colors from '../config/colors';

function RecommendScreen({route}) {
  const reportData = route.params;
  const [showReport, setShowReport] = useState(true);
  // const [recommendations, setRecommendations] = useState();
  // console.log(reportData, "kl");

  // useEffect(() => {});

  const calculateItemTotal = (item) => {
    let multipleTotal = 0;

    Object.keys(reportData.options[item]).map((entry) => {
      const itemValue = parseInt(reportData.options[item][entry]);
      // console.log(item, itemValue, "sk");
      multipleTotal += itemValue;
    });
    // reportData.options[item][
    //   Object.keys(reportData.options[item])[0]
    // ]
    return multipleTotal;
  };

  return (
    <Screen style={styles.container}>
      {/* <View style={{justifyContent: 'center', alignItems: 'center'}}> */}
      {/* <AppText textColor="green" style={{fontSize: 36, fontWeight: 'bold'}}>
          Score Report
        </AppText> */}
      {(Object.keys(reportData.submission_recommendation).length !== 0 ||
        showReport) && (
        <AppText
          style={{
            fontSize: 20,
            fontWeight: '600',
            marginTop: 20,
            alignSelf: 'center',
          }}>
          {!showReport
            ? Object.keys(reportData.submission_recommendation).length +
              ' Recommendation(s)'
            : reportData.type}
        </AppText>
      )}
      {Object.keys(reportData.submission_recommendation).length === 0 &&
        !showReport && (
          <View style={{justifyContent: 'center', flex: 1}}>
            <AppText
              style={{
                fontSize: 20,
                fontWeight: '600',
                marginTop: 20,
                alignSelf: 'center',
              }}>
              {!showReport ? 'There are no recommendations' : reportData.type}
            </AppText>
          </View>
        )}
      {/* </View> */}
      {(!showReport && Object.keys(reportData.submission_recommendation))
        .length > 0 && (
        <FlatList
          style={{margin: 20}}
          data={Object.keys(reportData.submission_recommendation)}
          keyExtractor={(item) => item?.toString()}
          renderItem={({item}) => {
            // console.log(item, "fkd", reportData.recommendations);
            return (
              <View style={[styles.recommendView, {justifyContent: 'center'}]}>
                <AppText
                  color="newGray"
                  textColor="black"
                  style={styles.recommendTitle}>
                  {reportData.submission_recommendation[item]}
                </AppText>
              </View>
            );
          }}
        />
      )}
      {showReport && (
        <FlatList
          style={{margin: 20}}
          data={Object.keys(reportData.options)}
          keyExtractor={(item) => {
            // console.log(
            //   reportData.options[item][
            //     Object.keys(reportData.options[item])[0]
            //   ],
            //   "kskl"
            // );
            return item.toString();
          }}
          renderItem={({item}) => (
            <View
              style={[styles.recommendView, {justifyContent: 'space-between'}]}>
              <AppText
                color="newGray"
                textColor="black"
                style={styles.recommendTitle}>
                {item}
              </AppText>
              <AppText
                color="newGray"
                textColor="black"
                style={styles.recommendPoints}>
                {calculateItemTotal(item)}
              </AppText>
            </View>
          )}
          ListFooterComponent={
            <AppText
              textColor="green"
              style={{
                fontSize: 42,
                fontWeight: 'bold',
                alignSelf: 'center',
                marginTop: 10,
              }}>
              Score{' '}
              {parseInt(reportData.totalPoints) > 100
                ? '100'
                : reportData.totalPoints}
            </AppText>
          }
        />
      )}
      <AppText
        color="recommend"
        textColor="black"
        onPress={() => setShowReport(!showReport)}
        style={{
          fontSize: 16,
          fontWeight: '500',
          marginTop: 10,
          alignSelf: 'center',
          marginBottom: 20,
          borderRadius: 6,
          paddingVertical: 5,
        }}>
        {!showReport ? '  Full Score Report  ' : '  Recommendations  '}
      </AppText>
    </Screen>
  );
}

const styles = StyleSheet.create({
  container: {
    // flex: 1,
    // alignItems: "center",
    // justifyContent: "center",
    // alignContent: "center",
  },
  recommendView: {
    flex: 1,
    flexDirection: 'row',
    borderRadius: 20,
    width: '100%',
    minHeight: 80,
    marginVertical: 10,
    backgroundColor: colors.newGray,
    alignItems: 'center',
    // justifyContent: "space-between",
  },
  recommendTitle: {
    marginLeft: 10,
    textAlign: 'left',
    marginRight: 80,
  },
  recommendPoints: {
    textAlign: 'center',
    fontWeight: '700',
    right: 10,
    position: 'absolute',
  },
});

export default RecommendScreen;
